import Config from "../src/classes/Config";

export default new Config();